import React from "react";
import { Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * 테스트 값 초기화 확인 — 개발/목 환경에서만 열린다.
 *
 * 판매 방식 선택까지 포함해 저장값과 체험 진행을 전부 비운다 —
 * 가이드를 처음 여는 사용자와 같은 상태에서 다시 밟아 볼 수 있게 한다.
 */
function PathPickStartGuideResetTestValuesDialog({
  isOpen,
  onClose,
  onConfirm,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick_guide:readiness.reset_confirm.title")}
      />
      <CustomApprovalModal.Body>
        <Text textStyle={"body-sm-medium"} color={"#444440"}>
          {t("path_pick_guide:readiness.reset_confirm.body")}
        </Text>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        cancelName={t("path_pick_guide:readiness.reset_confirm.cancel")}
        confirmName={t("path_pick_guide:readiness.reset_confirm.confirm")}
        onCancel={onClose}
        onConfirm={onConfirm}
      />
    </CustomApprovalModal>
  );
}

export default PathPickStartGuideResetTestValuesDialog;
